// components/feedback/ErrorState.jsx
import React from 'react'
import { AlertCircle } from 'lucide-react'
import { cn } from '../../lib/cn'
import { Button } from '../ui/Button'

export function ErrorState({
  title = 'Erreur',
  description,
  onRetry,
  className = '',
}) {
  return (
    <div className={cn(
      'rounded-3xl border border-rose-200 bg-rose-50 p-6 text-rose-900 shadow-sm',
      className
    )}>
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-rose-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="text-sm font-bold">{title}</div>
          {description && (
            <div className="mt-1 text-xs text-rose-800">{description}</div>
          )}
          {onRetry && (
            <div className="mt-4">
              <Button size="sm" variant="danger" onClick={onRetry}>
                Réessayer
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
